import { RangeOperationDialog } from '@/components/edit/range-operation-dialog'

export interface RemoveIntervalDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/** Removes every record and event within the chosen range entirely (not just its GPS). */
export function RemoveIntervalDialog({ open, onOpenChange }: RemoveIntervalDialogProps) {
  return (
    <RangeOperationDialog
      open={open}
      onOpenChange={onOpenChange}
      idPrefix="remove-interval"
      title="Remove interval"
      description="Deletes every record and event in this time range entirely. Laps and session boundaries are recalculated to stay consistent."
      confirmLabel="Remove interval"
      buildOperation={(start, end) => ({ type: 'removeInterval', start, end })}
    />
  )
}
